/* eslint-disable import/prefer-default-export */
import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { CookiesProvider } from 'react-cookie'
import { client } from './client'

// Runtime REST fetches (e.g. MFN feeds). Queries never run during SSR, so a
// single module-level client is safe.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
})

// eslint-disable-next-line react/display-name,react/prop-types
export const wrapRootElement = ({ element }) => (
  <CookiesProvider>
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={client}>
        <ApolloHooksProvider client={client}>{element}</ApolloHooksProvider>
      </ApolloProvider>
    </QueryClientProvider>
  </CookiesProvider>
)

// export default wrapRootElement;
